import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/" className="navbar-logo">
            我的博客
          </Link>
        </div>
        
        <ul className="navbar-menu">
          <li className={`navbar-item ${isActive('/')}`}>
            <Link to="/" className="navbar-link">
              首页
            </Link>
          </li>
          <li className={`navbar-item ${isActive('/archive')}`}>
            <Link to="/archive" className="navbar-link">
              归档
            </Link>
          </li>
          <li className={`navbar-item ${isActive('/write')}`}>
            <Link to="/write" className="navbar-link">
              写文章
            </Link>
          </li>
          <li className={`navbar-item ${isActive('/profile')}`}>
            <Link to="/profile" className="navbar-link">
              我的
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;